/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './page-not-found.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/errors/page-not-found/page-not-found.component';
const styles_PageNotFoundComponent:any[] = [i0.styles];
export const RenderType_PageNotFoundComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_PageNotFoundComponent,data:{}});
export function View_PageNotFoundComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',[['class',
      'container mt-4']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),1,'div',[['class','alert alert-warning'],['role','alert']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    Page Not Found\n  '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(null as any),
      (null as any));
}
export function View_PageNotFoundComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'page-not-found',
      ([] as any[]),(null as any),(null as any),(null as any),View_PageNotFoundComponent_0,
      RenderType_PageNotFoundComponent)),i1.ɵdid(1,49152,(null as any),0,i2.PageNotFoundComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const PageNotFoundComponentNgFactory:i1.ComponentFactory<i2.PageNotFoundComponent> = i1.ɵccf('page-not-found',
    i2.PageNotFoundComponent,View_PageNotFoundComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9hcHAvc3JjL2FwcC9lcnJvcnMvcGFnZS1ub3QtZm91bmQvcGFnZS1ub3QtZm91bmQuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9hcHAvc3JjL2FwcC9lcnJvcnMvcGFnZS1ub3QtZm91bmQvcGFnZS1ub3QtZm91bmQuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL2FwcC9zcmMvYXBwL2Vycm9ycy9wYWdlLW5vdC1mb3VuZC9wYWdlLW5vdC1mb3VuZC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci9hcHAvc3JjL2FwcC9lcnJvcnMvcGFnZS1ub3QtZm91bmQvcGFnZS1ub3QtZm91bmQuY29tcG9uZW50LnRzLlBhZ2VOb3RGb3VuZENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJjb250YWluZXIgbXQtNFwiPlxuICA8ZGl2IGNsYXNzPVwiYWxlcnQgYWxlcnQtd2FybmluZ1wiIHJvbGU9XCJhbGVydFwiPlxuICAgIFBhZ2UgTm90IEZvdW5kXG4gIDwvZGl2PlxuPC9kaXY+XG4iLCI8cGFnZS1ub3QtZm91bmQ+PC9wYWdlLW5vdC1mb3VuZD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUE0Qiw0Q0FDMUI7VUFBQTtVQUFBO01BQThDLGdFQUV4QztVQUFBLHVCQUNGOzs7O29CQ0pOO01BQUE7c0NBQUEsVUFBQTtNQUFBOzs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/errors/page-not-found/page-not-found.component.ngfactory.ts